import { useContext } from 'react';
import { BareModal } from '../../modal';
import GutentagSearchWebsiteForm from './GutentagSearchWebsiteForm';

const GutentagSearchWebsiteModal = ({
    controller,
}) => {

    return (
        <BareModal
            controller={controller}
            title="Finde deinen Fotografen"
        >
            <GutentagSearchWebsiteForm />
        </BareModal>
    );
}

export default GutentagSearchWebsiteModal;
